export default __webpack_public_path__ + "6f90a5bb5d450562cb73dd3a8502fbb7.glb";